import { 
    CLIENT_PROCEDURE_BEGIN,
    CLIENT_PROCEDURE_SUCCESS,
    CLIENT_PROCEDURE_FAILURE,
    CLIENT_PROCEDURE_CLEAR,

    CLIENT_PROCEDURE_FILTER_BEGIN,
    CLIENT_PROCEDURE_FILTER_SUCCESS,
    CLIENT_PROCEDURE_FILTER_FAILURE,
    CLIENT_PROCEDURE_FILTER_CLEAR

} from 'app/actions/ClientProcedureActions';

const initialState = {
    allIds: [],
    filterData: [],
	isLoading: false,
};

export default function ClientProcedureReducer (state = initialState, action) {
	switch (action.type) {
        case CLIENT_PROCEDURE_BEGIN: 
			return {
				...state,
				isLoading: true
			}
        case CLIENT_PROCEDURE_SUCCESS:
			let allIds = action.payload.data.Data;
			return {
				...state,
				allIds,
				isLoading: false,
            };
        case CLIENT_PROCEDURE_CLEAR:
            return {
                ...state,
                allIds: [],
                isLoading: false,
            }
        case CLIENT_PROCEDURE_FAILURE: 
			return {
				...state,
				isLoading: false
            }
        case CLIENT_PROCEDURE_FILTER_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case CLIENT_PROCEDURE_FILTER_SUCCESS:
            let filterData = [...new Set(state.filterData.concat(action.payload.filterData))];
            return {
                ...state,
                filterData,
                isLoading: false,
            };
        case CLIENT_PROCEDURE_FILTER_CLEAR:
            return {
                ...state,
                filterData: [],
                isLoading: false,
            }
        case CLIENT_PROCEDURE_FILTER_FAILURE:
            return {
                ...state,
                isLoading: false
            }
		default:
			return state;
	}
};

export const getClientProcedure = state => {
	return state.allIds;
}

export const getIsLoadingClientProcedure = state => {
    return state.isLoading;
}

export const getClientProcedureFilter = state => {
    return state.filterData
}
export const getIsLoadingClientProcedureFilter = state => {
    return state.isLoading;
}